var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    staticClass: "lazyload",
    class: _vm.custom_class,
    attrs: {
      "data-sizes": "auto",
      "data-widths":
        "[180,360,540,720,900,1080,1296,1512,1728,1944,2160,2376,2592,2808,3024]",
      "data-src": _vm.src
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }